import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ICourseOutcomeMetadata {
  id?: string;
  meta_image?: string;
  meta_image_alt?: string;
  meta_mobile_image?: string;
  meta_title?: string;
  meta_title_color?: string;
  meta_description?: string;
  meta_description_color?: string;
  meta_box_color?: string;
  meta_box_title?: string;
  meta_box_title_color?: string;
  meta_box_sub_title?: string;
  meta_box_sub_title_color?: string;
  priority?: number;
}

export interface ICourseOutcome {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  pre_title?: string;
  pre_title_text_color?: string;
  title?: string;
  title_gradient_angle?: string;
  title_gradient_start_color?: string;
  title_gradient_end_color?: string;
  description?: string;
  description_color?: string;
  load_more_button?: string;
  load_more_button_text_color?: string;
  background_variant?: string;
  metadata?: ICourseOutcomeMetadata[];
  variant?: string;
  status?: boolean;
}

export async function createCourseOutcome(payload: Partial<ICourseOutcome>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.COURSE_OUTCOME.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateCourseOutcome(id: number, payload: Partial<ICourseOutcome>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.COURSE_OUTCOME.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
